import { InjectionToken } from '@angular/core';

export interface OneTrustConfig {
    url: string;
    domainScript: string;
    disabled: boolean;
}

export const ONE_TRUST_CONFIG = new InjectionToken<OneTrustConfig>(
    'oneTrustConfig',
    {
        providedIn: 'root',
        factory: () => {
            return {
                url: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
                domainScript: '17ebc7f2-defd-49c9-b58a-0b30739564e9',
                disabled: false,
            };
        },
    },
);
